import { Injectable } from '@angular/core';
import {Router} from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class PrintService {
  isPrinting = false;

  constructor(private router: Router) { }

  printDocument(documentName: string, documentData: string[]) {
    console.log('document Name', documentName);
    console.log('document data', documentData);
    this.isPrinting = true;
    this.router.navigate(['/',
      { outlets: {
        print: ['print', documentName, documentData.join(',')]
      }}]);
  }

  onDataReady() {
    console.log('On data ready')
    setTimeout(() => {
      window.print();
      this.isPrinting = false;
      this.router.navigate([{ outlets: { print: null }}]);
    });
  }
}
